
export class EffortInfo {
  EffortId: number
  EffortPlanId: number
  EffortMonth: number
  EffortMonthYear: string
  EffortManDay: number
  EffortPricePerManDay: number
  EffortPriceTotal: number
  ETC: number
}
